// Generated from SVG to Code Figma Plugin

export const BaseLineReset = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.6568 17.6568C16.2092 19.1046 14.2092 20 12 20C7.58173 20 4 16.4183 4 12C4 7.58173 7.58173 4 12 4C14.2092 4 16.2092 4.89543 17.6568 6.34316C18.3937 7.08004 20 8.88889 20 8.88889"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M20 4.89062V8.89063H16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
